module.exports = require("assert");


/*****************
 ** WEBPACK FOOTER
 ** external "assert"
 ** module id = 17
 ** module chunks = 0
 **/